<template>
  <div class="hotel-alerts-wrapper">
    <div ref="header" class="hotel-alerts-header">
      <header-close :back="back">{{ selectedHotel.alertPanelTitle }} ({{filteredAlerts.length}})</header-close>
    </div>
    <div class="hotel-alerts-content" :style="[{ height: scrollHeight + 'px' }]">
      <h1 class="hotel-alerts-hotel">{{selectedHotel.propertyName}}</h1>
      <ul class="hotel-alerts-list">
        <li v-for="alert in filteredAlerts" :key="alert.id"  class="hotel-alerts-list-item">
          <h2 class="hotel-alerts-list-item-title">{{alert.title}}</h2>
          <div class="hotel-alerts-list-item-publish-date">{{dateFormatted(alert.publishDate)}}</div>
          <div
            v-if="alert.imageUrl"
            class="hotel-alerts-list-item-image"
          >
            <picture
              class="image-wrapper"
              v-lazyload="{
                src: alert.imageUrl,
                set: [
                  { width: '800', height: '450', breakpoint: 'xs' },
                  { width: '800', height: '450', breakpoint: 'md' }
                ],
                fit: 'crop',
                align: 'center'
              }">
              <img class="image" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" :alt="alert.imageAlt" />
            </picture>
          </div>
          <p
            class="hotel-alerts-list-item-description"
            v-html="alert.description"
          ></p>
          <a
            v-if="alert.ctaUrl"
            class="hotel-alerts-list-item-cta"
            :href="alert.ctaUrl"
            target="_blank"
          >
            <span class="hotel-alerts-list-item-cta-text">{{alert.ctaLabel}}</span>
            <em class="icon-chevron-right"></em>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import HeaderClose from "../header-close/header-close.vue";
import { formatDateZone, getAlertsThatOverlapsStayDateRange } from '@utils/date-helpers'

export default {
  name: "hotel-alerts",
  components: {
    HeaderClose,
  },
  inject: ["updateLocalQuery", "localQuery"],
  data: () => ({
    isLoading: false,
    tooltipOpened: false,
    scrollHeight: "auto",
  }),
  computed: {
    ...mapGetters("hotelData", ["getHotelById"]),
    ...mapGetters("i18n", ["tc"]),
    ...mapState("responsive", ["height", "width"]),

    selectedHotel() {
      return this.getHotelById(this.localQuery.hotelCode);
    },
    dateFormat() {
      return 'ddd[,] MMM DD[,] YYYY [@] HH:mm A'
    },
    filteredAlerts() {
      return getAlertsThatOverlapsStayDateRange(this.localQuery.stayDateStart, this.localQuery.stayDateEnd, this.selectedHotel.alerts)
    }

  },
  watch: {
    width() {
      this.calculateHeight()
    }
  },
  mounted() {
    this.$emit("change-width", "default")
    this.calculateHeight()
  },
  methods: {
    async submit() {
      this.isLoading = false;
      this.back();
    },
    back() {
      this.$emit("change-page", "confirmation");
    },
    calculateHeight() {
      const headerHeight = this.$refs.header.getBoundingClientRect().height
      this.scrollHeight = this.height - headerHeight
    },
     dateFormatted(date) {
      return formatDateZone(new Date(date), null, this.dateFormat)
    }
  },
};
</script>
